// import React from "react";
// import {
//   Paper,
//   Typography,
//   List,
//   ListItem,
//   ListItemText,
//   Chip,
//   Box,
//   Divider,
// } from "@mui/material";

// export default function SystemHealth({ health = {} }) {
//   const apiStatus = health.api ?? "unknown";
//   const integrations = Array.isArray(health.integrations)
//     ? health.integrations
//     : [];
//   const errors = Array.isArray(health.errors) ? health.errors : [];

//   const hasErrors = errors.length > 0;

//   const statusChipProps = (status) => {
//     const s = String(status || "").toLowerCase();
//     if (s === "ok" || s === "healthy") {
//       return { color: "success", label: status };
//     }
//     if (s === "degraded" || s === "warning") {
//       return { color: "warning", label: status };
//     }
//     return { color: "error", label: status || "unknown" };
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box sx={{ mb: 1.5 }}>
//         <Typography
//           variant="overline"
//           sx={{
//             fontSize: 11,
//             letterSpacing: 0.8,
//             textTransform: "uppercase",
//             color: "text.secondary",
//           }}
//         >
//           Status
//         </Typography>
//         <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
//           System Health
//         </Typography>
//       </Box>

//       <Box sx={{ mb: 2 }}>
//         <Typography
//           variant="subtitle2"
//           sx={{ fontWeight: 600, mb: 0.5 }}
//         >
//           Core Services
//         </Typography>
//         <List dense disablePadding>
//           <ListItem
//             sx={{
//               px: 0,
//               py: 0.5,
//               "&:not(:last-of-type)": {
//                 borderBottom: integrations.length
//                   ? "1px solid rgba(229,231,235,0.7)"
//                   : "none",
//               },
//             }}
//           >
//             <ListItemText
//               primary="API"
//               primaryTypographyProps={{ variant: "body2" }}
//             />
//             <Chip
//               size="small"
//               {...statusChipProps(apiStatus)}
//               sx={{
//                 ml: 1,
//                 borderRadius: 999,
//                 height: 22,
//                 fontSize: 11,
//                 fontWeight: 600,
//                 textTransform: "capitalize",
//               }}
//             />
//           </ListItem>

//           {integrations.map((i, idx) => {
//             const chip = statusChipProps(i.status);
//             return (
//               <ListItem
//                 key={i.name || idx}
//                 sx={{
//                   px: 0,
//                   py: 0.5,
//                   borderTop: "1px solid rgba(229,231,235,0.7)",
//                 }}
//               >
//                 <ListItemText
//                   primary={i.name}
//                   primaryTypographyProps={{ variant: "body2" }}
//                 />
//                 <Chip
//                   size="small"
//                   {...chip}
//                   sx={{
//                     ml: 1,
//                     borderRadius: 999,
//                     height: 22,
//                     fontSize: 11,
//                     fontWeight: 600,
//                     textTransform: "capitalize",
//                   }}
//                 />
//               </ListItem>
//             );
//           })}
//         </List>
//       </Box>

//       <Divider sx={{ mb: 2 }} />

//       {/* Errors */}
//       <Box sx={{ flex: 1, minHeight: 0 }}>
//         <Box
//           sx={{
//             mb: 0.5,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: 1,
//           }}
//         >
//           <Typography
//             variant="subtitle2"
//             sx={{ fontWeight: 600 }}
//           >
//             Recent Errors
//           </Typography>
//           <Typography
//             variant="caption"
//             color="text.secondary"
//           >
//             {hasErrors ? `${errors.length} issue${errors.length > 1 ? "s" : ""}` : "None"}
//           </Typography>
//         </Box>

//         <Box
//           sx={{
//             maxHeight: { xs: 180, sm: 220 },
//             overflowY: "auto",
//             borderRadius: 1,
//             border: "1px solid rgba(229,231,235,0.7)",
//             bgcolor: hasErrors ? "rgba(248,250,252,0.9)" : "transparent",
//           }}
//         >
//           <List dense disablePadding>
//             {hasErrors ? (
//               errors.map((e) => (
//                 <ListItem
//                   key={e.id}
//                   sx={{
//                     px: 1.5,
//                     py: 0.75,
//                     "&:not(:last-of-type)": {
//                       borderBottom: "1px solid rgba(229,231,235,0.7)",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary={
//                       <Typography
//                         variant="body2"
//                         sx={{ fontWeight: 500 }}
//                       >
//                         {e.message}
//                       </Typography>
//                     }
//                     secondary={
//                       <Typography
//                         variant="caption"
//                         color="text.secondary"
//                       >
//                         {new Date(e.timestamp).toLocaleString()}
//                       </Typography>
//                     }
//                   />
//                 </ListItem>
//               ))
//             ) : (
//               <ListItem sx={{ px: 1.5, py: 1 }}>
//                 <ListItemText
//                   primaryTypographyProps={{
//                     variant: "body2",
//                     color: "text.secondary",
//                   }}
//                   primary="No errors."
//                 />
//               </ListItem>
//             )}
//           </List>
//         </Box>
//       </Box>
//     </Paper>
//   );
// }


import React from "react";
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Box,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

export default function SystemHealth({ health = {} }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const apiStatus = health.api ?? "unknown";
  const integrations = Array.isArray(health.integrations)
    ? health.integrations
    : [];
  const errors = Array.isArray(health.errors) ? health.errors : [];

  const hasErrors = errors.length > 0;

  const statusChipProps = (status) => {
    const s = String(status || "").toLowerCase();

    if (s === "ok" || s === "healthy") {
      return {
        bg: dark ? "rgba(34,197,94,0.18)" : "rgba(34,197,94,0.10)",
        fg: dark ? "#86efac" : "#15803d",
        border: dark ? "rgba(34,197,94,0.24)" : "rgba(34,197,94,0.18)",
        label: status,
      };
    }

    if (s === "degraded" || s === "warning") {
      return {
        bg: dark ? "rgba(245,158,11,0.18)" : "rgba(245,158,11,0.12)",
        fg: dark ? "#fcd34d" : "#854d0e",
        border: dark ? "rgba(245,158,11,0.24)" : "rgba(245,158,11,0.18)",
        label: status,
      };
    }

    return {
      bg: dark ? alpha(accent, 0.14) : alpha(accent, 0.08),
      fg: accent,
      border: alpha(accent, 0.2),
      label: status || "unknown",
    };
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box sx={{ mb: 1.75 }}>
        <Typography
          sx={{
            fontSize: 11,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: muted,
            fontWeight: 500,
            fontFamily:
              '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
          }}
        >
          Status
        </Typography>

        <Typography
          sx={{
            mt: 0.6,
            fontWeight: 800,
            fontSize: "1.35rem",
            lineHeight: 1.15,
            color: text,
            letterSpacing: "-0.02em",
          }}
        >
          System Health
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography
          sx={{
            fontSize: "0.95rem",
            fontWeight: 700,
            color: text,
            mb: 0.8,
          }}
        >
          Core Services
        </Typography>

        <List dense disablePadding>
          <ListItem
            sx={{
              px: 0,
              py: 0.6,
              "&:not(:last-of-type)": {
                borderBottom: integrations.length ? `1px solid ${border}` : "none",
              },
            }}
          >
            <ListItemText
              primary="API"
              primaryTypographyProps={{ sx: { fontSize: "14px", color: text } }}
            />
            <Chip
              size="small"
              label={statusChipProps(apiStatus).label}
              sx={{
                ml: 1,
                borderRadius: 999,
                height: 24,
                fontSize: 11,
                fontWeight: 700,
                bgcolor: statusChipProps(apiStatus).bg,
                color: statusChipProps(apiStatus).fg,
                border: `1px solid ${statusChipProps(apiStatus).border}`,
                textTransform: "capitalize",
              }}
            />
          </ListItem>

          {integrations.map((i, idx) => {
            const chip = statusChipProps(i.status);

            return (
              <ListItem
                key={i.name || idx}
                sx={{
                  px: 0,
                  py: 0.6,
                  borderTop: `1px solid ${border}`,
                }}
              >
                <ListItemText
                  primary={i.name}
                  primaryTypographyProps={{ sx: { fontSize: "14px", color: text } }}
                />
                <Chip
                  size="small"
                  label={chip.label}
                  sx={{
                    ml: 1,
                    borderRadius: 999,
                    height: 24,
                    fontSize: 11,
                    fontWeight: 700,
                    bgcolor: chip.bg,
                    color: chip.fg,
                    border: `1px solid ${chip.border}`,
                    textTransform: "capitalize",
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </Box>

      <Divider sx={{ mb: 2, borderColor: border }} />

      <Box sx={{ flex: 1, minHeight: 0 }}>
        <Box
          sx={{
            mb: 0.65,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: "0.95rem",
              fontWeight: 700,
              color: text,
            }}
          >
            Recent Errors
          </Typography>

          <Typography
            sx={{
              fontSize: "12px",
              color: muted,
            }}
          >
            {hasErrors ? `${errors.length} issue${errors.length > 1 ? "s" : ""}` : "None"}
          </Typography>
        </Box>

        <Box
          sx={{
            maxHeight: { xs: 180, sm: 220 },
            overflowY: "auto",
            borderRadius: "16px",
            border: `1px solid ${border}`,
            bgcolor: hasErrors
              ? dark
                ? "rgba(255,255,255,0.02)"
                : "rgba(248,250,252,0.9)"
              : "transparent",
          }}
        >
          <List dense disablePadding>
            {hasErrors ? (
              errors.map((e) => (
                <ListItem
                  key={e.id}
                  sx={{
                    px: 1.5,
                    py: 0.85,
                    "&:not(:last-of-type)": {
                      borderBottom: `1px solid ${border}`,
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: text,
                          lineHeight: 1.6,
                        }}
                      >
                        {e.message}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        sx={{
                          mt: 0.3,
                          fontSize: "12px",
                          color: mid,
                        }}
                      >
                        {new Date(e.timestamp).toLocaleString()}
                      </Typography>
                    }
                  />
                </ListItem>
              ))
            ) : (
              <ListItem sx={{ px: 1.5, py: 1 }}>
                <ListItemText
                  primaryTypographyProps={{
                    sx: { fontSize: "14px", color: mid },
                  }}
                  primary="No errors."
                />
              </ListItem>
            )}
          </List>
        </Box>
      </Box>
    </Paper>
  );
}